'use strict';

function ArticleGallery() {
  this.id = null;
  this.node = null;
  this.extends = [];

  this.contentType = 'articleGallery';
  this.contentId = ''; // contentId defined in pug file
  this.articleId = null; // derived from url
  this.articleCount = null;
  this.articleIndex = null;

  this.elements = {};
  this.history = this.history ? this.history : new History();
  this.hasValidArticle = null;

  this.setArticleGalleryContent = function () {
    // find article for this page:
    this.articlesRef = 'content.' + this.contentType + '.' + this.contentId + '.articleSet.articles';
    this.articleId = window.location.hash.slice(1);
    this.articleIndex = this.findItemIndex(this.articlesRef, this.articleId);
    if (this.articleIndex === -1) {
      console.warn('ArticleGallery: article not found.');
      return false;
    }
    // change Product content reference from gallery object to a child article based on url hash:
    this.contentRef = 'content.' + this.contentType + '.' + this.contentId + '.articleSet.articles[' + this.articleIndex + ']';
    return true;
  };

  this.initArticleGallery = function () {
    var _this = this;

    this.hasValidArticle = this.setArticleGalleryContent();
    if (!this.hasValidArticle) {
      var defaultPage = location.pathname.substring(0, location.pathname.indexOf('/articles'));
      this.history.goToUrl(defaultPage);
      return;
    }

    this._product = new Product(this.contentRef, this.presenter);

    var url = window.location.href.replace('#', '/'); // for each article, analytics requires '/' replacing the '#' in the url
    this.analytics.pushEvent('virtual-page-view', { Page: [url] });
    this._product.pushContentfulAnalyticsEvent();

    // content elements:
    this.elements.media = this.node.querySelector('.js--media');
    this.elements.articleNumber = this.node.querySelector('.js--articleNumber');
    this.elements.headline = this.node.querySelector('.js--headline');
    this.elements.description = this.node.querySelector('.js--description');
    this.elements.buttonList = this.node.querySelector('.js--button-list');

    // load required components:
    this._product.loadMedia(this.elements.media);
    this._product.loadText(this.elements.articleNumber, 'articleNumber');
    this._product.loadText(this.elements.headline, 'headline');
    this._product.loadHTML(this.elements.description, 'description');

    // parse article content for any links
    var contentLinks = this.elements.description.querySelectorAll('a');
    if (contentLinks.length > 0) {
      contentLinks.forEach(function (element) {
        _this._product.setupLinkAction(element, element.getAttribute('href'));
        _this._product._addDaiToCta(element);
      });
    }

    if (this.elements.buttonList) {
      this._product.loadButtonList(this.elements.buttonList);
    }

    this.loadNavigation();
  };

  this.findItemIndex = function (ref, lookupId) {
    var itemsArr = this.presenter.getModelProperty('' + ref);
    var item = itemsArr.findIndex(function (item, index) {
      return item.id === lookupId;
    });
    return item;
  };

  // Navigation

  this.loadNavigation = function () {
    this.articleCount = this.presenter.getModelProperty('content.' + this.contentType + '.' + this.contentId + '.articleSet.articles.length');

    this.elements.paging = this.node.querySelector('.js--navigation-page-count');
    this.elements.previous = this.node.querySelector('.js--navigation-previous');
    this.elements.next = this.node.querySelector('.js--navigation-next');

    this.getPageInfo(this.elements.paging);

    if (this.articleIndex + 1 === this.articleCount) {
      this.elements.next.classList.add('disabled');
      this._addDaiToCta(this.elements.next, true);
    } else {
      var nextId = this.getNextId(this.articleIndex);
      this.elements.next.addEventListener('click', this.gotoArticle.bind(this, nextId));
      this._addDaiToCta(this.elements.next);
    }

    if (this.articleIndex === 0) {
      this.elements.previous.classList.add('disabled');
      this._addDaiToCta(this.elements.previous, true);
    } else {
      var previousId = this.getPreviousId(this.articleIndex);
      this.elements.previous.addEventListener('click', this.gotoArticle.bind(this, previousId));
      this._addDaiToCta(this.elements.previous);
    }
  };

  this.getPageInfo = function (element) {
    var info = '<span>' + (this.articleIndex + 1) + '</span><span> of </span><span>' + this.articleCount + '</span>';
    element.innerHTML = info;
  };

  this.getNextId = function (index) {
    if (index < this.articleCount - 1) {
      return this.getArticleId(index + 1);
    }
    return this.getArticleId(0);
  };

  this.getPreviousId = function (index) {
    if (index !== 0) {
      return this.getArticleId(index - 1);
    }
    return this.getArticleId(this.articleCount - 1);
  };

  this.getArticleId = function (index) {
    var itemsArr = this.presenter.getModelProperty(this.articlesRef);
    return itemsArr[index].id;
  };

  this.gotoArticle = function (nextId) {
    var url = location.pathname + '#' + nextId;
    this.history.goToUrl(url);
  };

  this._addDaiToCta = function (ctaElement, isDisabled) {
    var dai = null;
    if (ctaElement.classList.contains('js--navigation-previous')) {
      if (isDisabled) {
        dai = 'Contentful-Contentful Navigation-Prev Inactive-Navigation-Component';
      } else {
        dai = 'Contentful-Contentful Navigation-Prev-Navigation-Component';
      }
    } else if (ctaElement.classList.contains('js--navigation-next')) {
      if (isDisabled) {
        dai = 'Contentful-Contentful Navigation-Next Inactive-Navigation-Component';
      } else {
        dai = 'Contentful-Contentful Navigation-Next-Navigation-Component';
      }
    }
    ctaElement.setAttribute('data-analytics-id', dai);
  };

  this.destroyArticleGallery = function () {
    if (this._product) {
      this._product.destroy();
    }
  };

  // Template file is not first component extended so don't use these
  this.init = function () {};

  this.initAllReady = function () {};

  this.destroy = function () {};
}